$(function() {
  $(document).foundation();
});